import { NgModule } from '@angular/core';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CarouselComponent } from './carousel/carousel.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { GalleryComponent } from './gallery/gallery.component';
import { VideoAboutComponent } from './video-about/video-about.component';

const COMPONENTS = [
  ContactUsComponent,
  CarouselComponent,
  GalleryComponent,
  VideoAboutComponent
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    BrowserModule,
    NgbModule
  ],
  exports: [...COMPONENTS],
})
export class ScenesModule { }
